<script setup lang="ts">
  withDefaults(defineProps<{ size?: number | string }>(), { size: 18 })
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M20 8V6.5a1 1 0 0 0-1.25-.97L4 9" />
    <rect x="3" y="8" width="18" height="11.5" rx="2" />
    <path d="M21 12h-3a1.75 1.75 0 0 0 0 3.5h3" />
  </svg>
</template>
